"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventFieldCustom = void 0;
var TraitDataType_1 = require("./TraitDataType");
var EventFieldBase_1 = require("./EventFieldBase");
var EventFieldCustom = (function () {
    function EventFieldCustom(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.dataType = TraitDataType_1.TraitDataType[data.dataType];
        this.target = data.target;
        this.meta = typeof data.meta !== 'undefined' ? Object.keys(data.meta).reduce(function (previous, current) { previous[current] = data.meta[current]; return previous; }, {}) : undefined;
        this.name = data.name;
        this.description = typeof data.description !== 'undefined' ? data.description : undefined;
    }
    EventFieldCustom.prototype.getPackageName = function () { return EventFieldCustom.PackageName; };
    EventFieldCustom.prototype.getClassName = function () { return EventFieldCustom.ClassName; };
    EventFieldCustom.prototype.getFullClassName = function () { return EventFieldCustom.FullClassName; };
    Object.defineProperty(EventFieldCustom.prototype, "dataType", {
        get: function () {
            return this._dataType;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field dataType is not optional');
            }
            this._dataType = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventFieldCustom.prototype, "target", {
        get: function () {
            return this._target;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field target is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field target expects type string, got ' + value);
            }
            this._target = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventFieldCustom.prototype, "meta", {
        get: function () {
            return this._meta;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._meta = undefined;
                return;
            }
            this._meta = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventFieldCustom.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EventFieldCustom.prototype, "description", {
        get: function () {
            return this._description;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._description = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field description expects type string, got ' + value);
            }
            this._description = value;
        },
        enumerable: false,
        configurable: true
    });
    EventFieldCustom.prototype.toEventFieldBaseSerialized = function () {
        var _this = this;
        return {
            dataType: TraitDataType_1.TraitDataType[this.dataType],
            target: this.target,
            meta: typeof this.meta !== 'undefined' ? Object.keys(this.meta).reduce(function (previous, current) { previous[current] = _this.meta[current]; return previous; }, {}) : undefined
        };
    };
    EventFieldCustom.prototype.toEventFieldBase = function () {
        return new EventFieldBase_1.EventFieldBaseStruct(this.toEventFieldBaseSerialized());
    };
    EventFieldCustom.prototype.loadEventFieldBaseSerialized = function (slice) {
        this.dataType = TraitDataType_1.TraitDataType[slice.dataType];
        this.target = slice.target;
        this.meta = typeof slice.meta !== 'undefined' ? Object.keys(slice.meta).reduce(function (previous, current) { previous[current] = slice.meta[current]; return previous; }, {}) : undefined;
    };
    EventFieldCustom.prototype.loadEventFieldBase = function (slice) {
        this.loadEventFieldBaseSerialized(slice.serialize());
    };
    EventFieldCustom.prototype.serialize = function () {
        var _this = this;
        return {
            dataType: TraitDataType_1.TraitDataType[this.dataType],
            target: this.target,
            meta: typeof this.meta !== 'undefined' ? Object.keys(this.meta).reduce(function (previous, current) { previous[current] = _this.meta[current]; return previous; }, {}) : undefined,
            name: this.name,
            description: typeof this.description !== 'undefined' ? this.description : undefined
        };
    };
    EventFieldCustom.PackageName = 'net.playq.octopus2.analytics';
    EventFieldCustom.ClassName = 'EventFieldCustom';
    EventFieldCustom.FullClassName = 'net.playq.octopus2.analytics.EventFieldCustom';
    return EventFieldCustom;
}());
exports.EventFieldCustom = EventFieldCustom;
EventFieldBase_1.EventFieldBaseStruct.register(EventFieldCustom.FullClassName, EventFieldCustom);
var irt_1 = require("@playq/irt");
irt_1.Introspector.register(EventFieldCustom.FullClassName, {
    full: EventFieldCustom.FullClassName,
    short: EventFieldCustom.ClassName,
    package: EventFieldCustom.PackageName,
    type: irt_1.IntrospectorTypes.Data,
    ctor: function () { return new EventFieldCustom(); },
    fields: [
        {
            name: 'dataType',
            accessName: 'dataType',
            type: { intro: irt_1.IntrospectorTypes.Enum, full: 'net.playq.octopus2.analytics.TraitDataType' }
        },
        {
            name: 'target',
            accessName: 'target',
            type: { intro: irt_1.IntrospectorTypes.Str }
        },
        {
            name: 'meta',
            accessName: 'meta',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.Map, key: { intro: irt_1.IntrospectorTypes.Str }, value: { intro: irt_1.IntrospectorTypes.Str } } }
        },
        {
            name: 'name',
            accessName: 'name',
            type: { intro: irt_1.IntrospectorTypes.Str }
        },
        {
            name: 'description',
            accessName: 'description',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.Str } }
        }
    ]
});
//# sourceMappingURL=EventFieldCustom.js.map